import styled from 'styled-components';
import { layout } from 'src/components/base';
import { CaptionText } from '@prisjakt/ui/text/variants';

export const StyledDeliveryTime = styled.div`
  display: flex;
  align-items: center;
  gap: ${layout.measurements.spacing025};
`;

export const StyledDeliveryText = styled.div`
  white-space: nowrap;
`;

export const StyledLabel = styled(CaptionText)`
  /* Do not show label on smaller screens to prevent layout from breaking */
  @media screen and (max-width: 410px) {
    display: none;
  }
`;
